import React, { useState } from "react"
import { useEffect } from "react"

const GetButton = () => {
  const [color, setColor] = useState(false)

  useEffect(() => {
    const handleColor = () => {
      if (window.pageYOffset > 500) {
        setColor(true)
      } else {
        setColor(false)
      }
    }
    window.addEventListener("scroll", handleColor)
    return () => window.removeEventListener("scroll", handleColor)
  }, [color])

  return (
    <a href="#getRJN" className="text-white">
      <div
        className={`${
          color
            ? "d-flex justify-content-center get-started clr-change"
            : "d-flex justify-content-center get-started"
        }`}
      >
        <p>Get Started</p>
      </div>
    </a>
  )
}

export default GetButton
